module.exports = __webpack_public_path__ + "static/media/analytices8.5d261e5b.jpg";